import { render, staticRenderFns } from "./vipFooter.vue?vue&type=template&id=9f33df5c&scoped=true&"
import script from "./vipFooter.vue?vue&type=script&lang=ts&"
export * from "./vipFooter.vue?vue&type=script&lang=ts&"
import style0 from "./vipFooter.vue?vue&type=style&index=0&id=9f33df5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f33df5c",
  null
  
)

export default component.exports